module.exports = __webpack_public_path__ + "img/zizhi15.9c8058bc.png";